<mat-card class="simplified-form-card" [class]="{'wizard-mode': isMultiPage, 'bautagebuch-mode': isBautagebuchMode, 'tagesbericht-nu-mode': isTagesberichtNUMode}">

  <!-- ===== TAGESBERICHT NACHUNTERNEHMER MODE ===== -->
  <ng-container *ngIf="isTagesberichtNUMode">
    <mat-card-header class="bautagebuch-header">
      <div class="bautagebuch-title-row">
        <div class="header-title-group">
          <span class="header-title-icon" aria-hidden="true">
            <mat-icon>assignment</mat-icon>
          </span>
          <div>
            <mat-card-title>Tagesbericht (Nachunternehmer)</mat-card-title>
            <mat-card-subtitle>{{ form?.get('project.gewerk')?.value || 'Gewerk' }} — {{ form?.get('project.nachunternehmer')?.value || 'Ihre Firma' }}</mat-card-subtitle>
          </div>
        </div>
      </div>
    </mat-card-header>

    <mat-progress-bar mode="indeterminate" *ngIf="loading || nuDraftSaveInProgress"></mat-progress-bar>

    <mat-card-content *ngIf="error">
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{error}}</span>
      </div>
    </mat-card-content>

    <mat-card-content *ngIf="!loading && !error && form" class="bautagebuch-content" #scrollableContent>
      <div *ngIf="isReadOnlyPreview" class="read-only-notice read-only-notice--workspace">
        <mat-icon>visibility</mat-icon>
        <span>Vorschau-Modus: Der Tagesbericht ist formatiert lesbar, aber nicht bearbeitbar.</span>
      </div>

      <div [formGroup]="form" [class.read-only-preview-content]="isReadOnlyPreview">
        <ng-container>

        <!-- TOP ROW: Datum + Vorarbeiter + Vorlage + Actions -->
        <div class="bautagebuch-top-row" *ngIf="!isReadOnlyPreview">
          <mat-form-field appearance="outline" class="compact-field date-field">
            <mat-label>Datum</mat-label>
            <input matInput [matDatepicker]="nuDatePicker" [formControl]="datumPickerControl"
              placeholder="DD.MM.YYYY" (dateChange)="onBautagebuchDateChange($event.value)">
            <mat-datepicker-toggle matSuffix [for]="nuDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #nuDatePicker></mat-datepicker>
            <mat-error *ngIf="datumPickerControl.hasError('matDatepickerParse')">Ungültiges Datum</mat-error>
          </mat-form-field>

          <div formGroupName="day">
            <mat-form-field appearance="outline" class="compact-field date-field">
              <mat-label>Vorarbeiter</mat-label>
              <input matInput formControlName="vorarbeiter">
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="compact-field preset-select top-row-select">
            <mat-label>Vorlage</mat-label>
            <mat-select [value]="tagesberichtNUTemplateId" (selectionChange)="applyTagesberichtNUTemplate($event.value)">
              <mat-option [value]="null">Keine Vorlage</mat-option>
              <mat-option *ngFor="let template of tagesberichtNUTemplates" [value]="template.id">
                <mat-icon *ngIf="isNUSystemTemplate(template)" style="font-size:14px;vertical-align:middle">lock</mat-icon>
                {{ template.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="toolbar-actions top-row-actions" *ngIf="!isReadOnlyPreview">
            <button mat-stroked-button color="primary" (click)="saveTagesberichtNUTemplate(false)" [disabled]="isNuUiBusy">Vorlage speichern</button>
            <button mat-stroked-button (click)="saveTagesberichtNUTemplate(true)"
              [disabled]="isNuUiBusy || !tagesberichtNUTemplateId || isNUSelectedTemplateSystem()">Vorlage aktualisieren</button>
            <button mat-stroked-button color="warn" (click)="deleteTagesberichtNUTemplate()"
              [disabled]="isNuUiBusy || !tagesberichtNUTemplateId || isNUSelectedTemplateSystem()">Vorlage löschen</button>
            <button mat-stroked-button (click)="previewTagesberichtNUXml()" [disabled]="isNuUiBusy">XML-Vorschau</button>
          </div>
        </div>

        <!-- TWO-COLUMN LAYOUT -->
        <div class="bautagebuch-layout bautagebuch-form">

          <!-- ===== LEFT COLUMN ===== -->
          <div class="bautagebuch-main">

            <!-- SUMMARY GRID: Projekt + Wetter -->
            <div class="bautagebuch-summary-grid">

              <!-- Projekt / Baustelle (collapsible) -->
              <mat-card class="section-card section-card-compact" *ngIf="showNuPreviewSection('project')">
                <div class="summary-card-header">
                  <div>
                    <mat-card-title>Projekt / Baustelle</mat-card-title>
                    <ng-container *ngIf="!showProjectEditor">
                      <div class="summary-title">{{ form.get('project.bezeichnung')?.value || '—' }}</div>
                      <div class="summary-meta">
                        <ng-container *ngIf="form.get('project.generalunternehmer')?.value">GU: {{ form.get('project.generalunternehmer')?.value }}</ng-container>
                        <ng-container *ngIf="form.get('project.gewerk')?.value"> · {{ form.get('project.gewerk')?.value }}</ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <button mat-icon-button class="icon-action-button" *ngIf="!isReadOnlyPreview" (click)="showProjectEditor = !showProjectEditor">
                    <mat-icon>{{ showProjectEditor ? 'expand_less' : 'edit' }}</mat-icon>
                  </button>
                </div>
                <div formGroupName="project" *ngIf="showProjectEditor" class="summary-editor">
                  <mat-form-field appearance="outline" class="full-width compact-field">
                    <mat-label>Bezeichnung der Baumaßnahme</mat-label>
                    <input matInput formControlName="bezeichnung" placeholder="z.B. Neubau Musterstraße 12">
                  </mat-form-field>
                  <div class="bt-fields-row">
                    <mat-form-field appearance="outline" class="compact-field half-width">
                      <mat-label>Generalunternehmer</mat-label>
                      <input matInput formControlName="generalunternehmer">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field half-width">
                      <mat-label>Ihre Firma (Nachunternehmer)</mat-label>
                      <input matInput formControlName="nachunternehmer">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field half-width">
                      <mat-label>Gewerk</mat-label>
                      <input matInput formControlName="gewerk" placeholder="z.B. Schalung / Betonbau">
                    </mat-form-field>
                  </div>
                </div>
              </mat-card>

              <!-- Wetter (collapsible, identical to Bautagebuch) -->
              <mat-card class="section-card section-card-compact" *ngIf="showNuPreviewSection('weather')">
                <div class="summary-card-header">
                  <div>
                    <mat-card-title class="weather-summary-title">
                      <mat-icon>{{ weatherSummaryIcon }}</mat-icon>
                      <span>Wetter</span>
                    </mat-card-title>
                    <ng-container *ngIf="!showWeatherEditor">
                      <div class="summary-title">{{ weatherSummaryTitle }}</div>
                      <div class="summary-meta">{{ weatherSummaryMeta }}</div>
                    </ng-container>
                  </div>
                  <button mat-icon-button class="icon-action-button" *ngIf="!isReadOnlyPreview" (click)="showWeatherEditor = !showWeatherEditor">
                    <mat-icon>{{ showWeatherEditor ? 'expand_less' : 'edit' }}</mat-icon>
                  </button>
                </div>
                <div formGroupName="weather" *ngIf="showWeatherEditor" class="summary-editor">
                  <div class="weather-editor-grid">
                    <mat-form-field appearance="outline" class="compact-field">
                      <mat-label>Wetterlage</mat-label>
                      <mat-select formControlName="tageslage">
                        <mat-option *ngFor="let opt of weatherOptions; trackBy: trackByOptionValue" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field temperature-field weather-temperature-field">
                      <mat-label>Min. Temperatur</mat-label>
                      <input matInput type="number" formControlName="temperaturMinC">
                      <span matTextSuffix>°C</span>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field temperature-field weather-temperature-field">
                      <mat-label>Max. Temperatur</mat-label>
                      <input matInput type="number" formControlName="temperaturMaxC">
                      <span matTextSuffix>°C</span>
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="full-width compact-field">
                    <mat-label>Bemerkung</mat-label>
                    <textarea matInput rows="2" formControlName="bemerkung"></textarea>
                  </mat-form-field>
                </div>
              </mat-card>

            </div><!-- END SUMMARY GRID -->
            <!-- IHRE FIRMA: header + Arbeitskräfte (full width, no right column) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('nuFirma')">
              <mat-card-title>Ihre Firma</mat-card-title>

              <div class="company-report-header" formGroupName="nuFirma">
                <div class="company-report-header-main">
                  <div formGroupName="firma">
                    <mat-form-field appearance="outline" class="company-report-company-field">
                      <mat-label>Firmenname</mat-label>
                      <input matInput formControlName="name">
                    </mat-form-field>
                  </div>
                  <div class="company-report-time-groups">
                    <div class="company-report-time-group" formGroupName="arbeitszeit">
                      <div class="company-report-inline-group-text">
                        <span class="company-report-inline-group-label">Arbeitszeit:</span>
                      </div>
                      <div class="company-report-time-fields">
                        <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Beginn</mat-label><input matInput type="time" formControlName="beginn"></mat-form-field>
                        <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Ende</mat-label><input matInput type="time" formControlName="ende"></mat-form-field>
                      </div>
                    </div>
                    <div class="company-report-time-group" formGroupName="schlechtesWetter">
                      <div class="company-report-inline-group-text">
                        <span class="company-report-inline-group-label">Schlechtes Wetter:</span>
                      </div>
                      <div class="company-report-time-fields">
                        <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Beginn</mat-label><input matInput type="time" formControlName="beginn"></mat-form-field>
                        <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Ende</mat-label><input matInput type="time" formControlName="ende"></mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Arbeitskräfte full-width -->
              <div class="report-column" formGroupName="nuFirma">
                <h4>Arbeitskräfte</h4>
                <div formArrayName="arbeitskraefte">
                  <div *ngFor="let worker of getNUWorkerControls(); let wi = index; trackBy: trackByControl"
                       [formGroupName]="wi" class="worker-card">
                    <div class="worker-row">
                      <mat-form-field appearance="outline">
                        <mat-label>Qualifikation</mat-label>
                        <mat-select formControlName="qualifikation">
                          <mat-option *ngFor="let opt of workerQualificationOptions; trackBy: trackByOptionValue" [value]="opt.value">{{ opt.label }}</mat-option>
                          <mat-option value="__custom__">Sonstige...</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline"><mat-label>Anzahl</mat-label><input matInput type="number" min="0" formControlName="anzahl"></mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Lohngruppe</mat-label>
                        <mat-select formControlName="lohngruppe">
                          <mat-option value="">—</mat-option>
                          <mat-option *ngFor="let opt of workerLohngruppeOptions; trackBy: trackByOptionValue" [value]="opt.value">{{ opt.value }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeNUWorker(wi)" [disabled]="getNUArbeitskraefte().length <= 1">
                        <mat-icon>remove_circle</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <button mat-stroked-button type="button" (click)="addNUWorker()">+ Arbeitskraft</button>
              </div>
            </mat-card><!-- END Ihre Firma -->

            <!-- AUSGEFÜHRTE ARBEITEN (always shown, stacked below Firma) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('ausgefuehrteArbeiten')">
              <div class="summary-card-header">
                <mat-card-title>Ausgeführte Arbeiten</mat-card-title>
                <button mat-icon-button color="primary" class="icon-action-button" type="button"
                  (click)="addNUAusgefuehrteArbeitenEntry()" matTooltip="Eintrag hinzufügen">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              <div formArrayName="ausgefuehrteArbeiten">
                <div *ngFor="let item of getNUAusgefuehrteArbeiten().controls; let i = index; trackBy: trackByControl"
                     [formGroupName]="i" class="optional-card">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Beschreibung der Arbeiten</mat-label>
                    <textarea matInput rows="3" formControlName="beschreibung"></textarea>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Arbeitsfortschritt</mat-label>
                    <input matInput formControlName="arbeitsfortschritt" placeholder="z.B. W1 100%">
                  </mat-form-field>
                  <div class="section-card-actions" *ngIf="getNUAusgefuehrteArbeiten().length > 1">
                    <button mat-stroked-button color="warn" type="button" (click)="removeNUAusgefuehrteArbeitenEntry(i)">Eintrag entfernen</button>
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- BEHINDERUNGEN (stacked, shown if active) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('behinderungen') && isTagesberichtNUSectionSelected('behinderungen')">
              <div class="summary-card-header">
                <mat-card-title>Behinderungen / Unterbrechungen</mat-card-title>
                <div style="display:flex;gap:4px">
                  <button mat-icon-button color="primary" class="icon-action-button" type="button" (click)="addNUBehinderungEntry()"><mat-icon>add</mat-icon></button>
                  <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeTagesberichtNUSection('behinderungen')" matTooltip="Abschnitt entfernen"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
              <div *ngFor="let item of nuBehinderungControls; let i = index; trackBy: trackByControl"
                   [formGroup]="item" class="optional-card">
                <div class="bt-fields-row">
                  <mat-form-field appearance="outline" class="half-width"><mat-label>Beginn</mat-label><input matInput type="time" formControlName="beginn"></mat-form-field>
                  <mat-form-field appearance="outline" class="half-width"><mat-label>Ende</mat-label><input matInput type="time" formControlName="ende"></mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="full-width"><mat-label>Ursache / Beschreibung</mat-label><input matInput formControlName="ursache"></mat-form-field>
                <mat-form-field appearance="outline" class="full-width"><mat-label>Betroffener Bereich</mat-label><input matInput formControlName="betroffenerBereich"></mat-form-field>
                <div class="bt-fields-row">
                  <mat-form-field appearance="outline" class="half-width"><mat-label>Pers. betroffen</mat-label><input matInput type="number" formControlName="betroffenePersonalAnzahl"></mat-form-field>
                  <mat-form-field appearance="outline" class="half-width"><mat-label>Ausweichmaßnahme</mat-label><input matInput formControlName="ausweichmassnahme"></mat-form-field>
                </div>
                <div class="section-card-actions">
                  <button mat-stroked-button color="warn" type="button" (click)="removeNUBehinderungEntry(i)">Eintrag entfernen</button>
                </div>
              </div>
              <div *ngIf="nuBehinderungControls.length === 0" class="bt-empty-hint">Noch keine Behinderungen — klicken Sie auf + um einen Eintrag hinzuzufügen.</div>
            </mat-card>

            <!-- GERÄTE (stacked, shown if active) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('geraete') && isTagesberichtNUSectionSelected('geraete')">
              <div class="summary-card-header">
                <mat-card-title>Geräte / Maschinen</mat-card-title>
                <div style="display:flex;gap:4px">
                  <button mat-icon-button color="primary" class="icon-action-button" type="button" (click)="addNUGeraetEntry()"><mat-icon>add</mat-icon></button>
                  <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeTagesberichtNUSection('geraete')" matTooltip="Abschnitt entfernen"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
              <div formArrayName="geraete">
                <div *ngFor="let item of getNUGeraete().controls; let i = index; trackBy: trackByControl"
                     [formGroupName]="i" class="optional-card">
                  <div class="form-grid three-columns">
                    <mat-form-field appearance="outline"><mat-label>Bezeichnung</mat-label><input matInput formControlName="bezeichnung"></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Typ</mat-label><input matInput formControlName="typ"></mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Status</mat-label>
                      <mat-select formControlName="status">
                        <mat-option *ngFor="let opt of getGeraeteStatusOptions()" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>                  <mat-form-field appearance="outline" class="full-width"><mat-label>Notiz</mat-label><input matInput formControlName="notiz"></mat-form-field>
                  <div class="section-card-actions">
                    <button mat-stroked-button color="warn" type="button" (click)="removeNUGeraetEntry(i)">Eintrag entfernen</button>
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- MATERIAL (stacked, shown if active) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('material') && isTagesberichtNUSectionSelected('material')">
              <div class="summary-card-header">
                <mat-card-title>Material / Lieferungen</mat-card-title>
                <div style="display:flex;gap:4px">
                  <button mat-icon-button color="primary" class="icon-action-button" type="button" (click)="addNUMaterialEntry()"><mat-icon>add</mat-icon></button>
                  <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeTagesberichtNUSection('material')" matTooltip="Abschnitt entfernen"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
              <div formArrayName="material">
                <div *ngFor="let item of getNUMaterial().controls; let i = index; trackBy: trackByControl"
                     [formGroupName]="i" class="optional-card">
                  <mat-form-field appearance="outline" class="full-width"><mat-label>Material / Bauteil</mat-label><input matInput formControlName="materialOderBauteil"></mat-form-field>
                  <div class="form-grid three-columns">
                    <mat-form-field appearance="outline"><mat-label>Menge</mat-label><input matInput formControlName="menge"></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Einheit</mat-label><input matInput formControlName="mengeneinheit"></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Lieferschein-Nr.</mat-label><input matInput formControlName="lieferscheinNr"></mat-form-field>
                  </div>
                  <div class="section-card-actions">
                    <button mat-stroked-button color="warn" type="button" (click)="removeNUMaterialEntry(i)">Eintrag entfernen</button>
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- WEISUNGEN (stacked, shown if active) -->
            <mat-card class="section-card" *ngIf="showNuPreviewSection('weisungen') && isTagesberichtNUSectionSelected('weisungen')">
              <div class="summary-card-header">
                <mat-card-title>Weisungen / Anordnungen</mat-card-title>
                <div style="display:flex;gap:4px">
                  <button mat-icon-button color="primary" class="icon-action-button" type="button" (click)="addNUWeisungEntry()"><mat-icon>add</mat-icon></button>
                  <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeTagesberichtNUSection('weisungen')" matTooltip="Abschnitt entfernen"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
              <div formArrayName="weisungen">
                <div *ngFor="let item of getNUWeisungen().controls; let i = index; trackBy: trackByControl"
                     [formGroupName]="i" class="optional-card">
                  <div class="bt-fields-row">
                    <mat-form-field appearance="outline" class="half-width"><mat-label>Zeitpunkt</mat-label><input matInput type="time" formControlName="zeitpunkt"></mat-form-field>
                    <mat-form-field appearance="outline" class="half-width"><mat-label>Angewiesen von</mat-label><input matInput formControlName="angewiesenVon"></mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="full-width"><mat-label>Inhalt</mat-label><textarea matInput rows="2" formControlName="inhalt"></textarea></mat-form-field>
                  <div class="section-card-actions">
                    <button mat-stroked-button color="warn" type="button" (click)="removeNUWeisungEntry(i)">Eintrag entfernen</button>
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- GENERIC OPTIONAL SECTIONS (pruefungen, verdeckteLeistungen, vorkommnisse — stacked) -->
            <ng-container *ngFor="let section of tagesberichtNUActiveOptionalSections; trackBy: trackBySectionId">
              <mat-card class="section-card"
                *ngIf="showNuPreviewSection(section.id) && section.id !== 'behinderungen' && section.id !== 'geraete' && section.id !== 'material' && section.id !== 'weisungen'">
                <div class="summary-card-header">
                  <mat-card-title>{{ section.title }}</mat-card-title>
                  <div style="display:flex;gap:4px">
                    <button mat-icon-button color="primary" class="icon-action-button" type="button" (click)="addNUSectionItem(section.id)"><mat-icon>add</mat-icon></button>
                    <button mat-icon-button color="warn" class="icon-action-button" type="button" (click)="removeTagesberichtNUSection(section.id)" matTooltip="Abschnitt entfernen"><mat-icon>delete</mat-icon></button>
                  </div>
                </div>
                <div [formArrayName]="section.id">
                  <div *ngFor="let item of getNUSectionFormArray(section.id).controls; let i = index; trackBy: trackByControl"
                       [formGroupName]="i" class="optional-card">
                    <div class="form-grid three-columns">
                      <mat-form-field appearance="outline" *ngFor="let field of section.fields; trackBy: trackByFieldKey">
                        <mat-label>{{ field.label }}</mat-label>
                        <ng-container [ngSwitch]="field.inputType">
                          <mat-select *ngSwitchCase="'select'" [formControlName]="field.key">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</mat-option>
                          </mat-select>
                          <input *ngSwitchDefault matInput [type]="field.inputType" [formControlName]="field.key">
                        </ng-container>
                      </mat-form-field>
                    </div>
                    <div class="section-card-actions">
                      <button mat-stroked-button color="warn" type="button" (click)="removeNUSectionItem(section.id, i)">Eintrag entfernen</button>
                    </div>
                  </div>
                </div>
              </mat-card>
            </ng-container>

            <!-- INTERNE FELDER (always shown, internal only) -->
            <mat-card class="section-card section-card-intern" formGroupName="interneFelder" *ngIf="showNuPreviewSection('interneFelder')">
              <div class="summary-card-header">
                <div>
                  <mat-card-title>
                    <mat-icon class="intern-icon">lock</mat-icon>
                    Interne Felder
                  </mat-card-title>
                  <div class="summary-meta">Nur für Ihre interne Steuerung — wird standardmäßig nicht an den GU übermittelt</div>
                </div>
              </div>
              <div class="intern-field-row" style="margin-top:10px">
                <mat-form-field appearance="outline" class="full-width compact-field intern-form-field">
                  <mat-label>Interne Zuordnung</mat-label>
                  <input matInput formControlName="interneZuordnung" placeholder="z. B. KST-200 / LV 03.2.15 – Wandschalung EG Süd">
                </mat-form-field>
                <mat-icon class="intern-info-icon" matTooltip="Ordnen Sie den Tageseintrag Ihrer internen Kostenstelle, Position oder Ihrem Arbeitspaket zu. Dieses Feld dient nur Ihrer internen Steuerung und wird nicht an den Generalunternehmer übermittelt." matTooltipPosition="right" matTooltipClass="intern-tooltip">info_outline</mat-icon>
              </div>
              <div class="intern-field-row">
                <mat-form-field appearance="outline" class="full-width compact-field intern-form-field">
                  <mat-label>Soll / Ist Leistung</mat-label>
                  <input matInput formControlName="sollIstLeistung" placeholder="z. B. Soll: 25 m², Ist: 18 m²">
                </mat-form-field>
                <mat-icon class="intern-info-icon" matTooltip="Erfassen Sie die intern geplante Tagesleistung und die tatsächlich erreichte Leistung. So können Sie Abweichungen früh erkennen. Dieses Feld ist nur für Ihre interne Auswertung." matTooltipPosition="right" matTooltipClass="intern-tooltip">info_outline</mat-icon>
              </div>
              <div class="intern-field-row">
                <mat-form-field appearance="outline" class="full-width compact-field intern-form-field">
                  <mat-label>Produktive Zeit / Verlustzeit</mat-label>
                  <input matInput formControlName="produktiveZeitVerlustzeit" placeholder="z. B. Produktiv: 42,0 h / Verlustzeit: 5,5 h">
                </mat-form-field>
                <mat-icon class="intern-info-icon" matTooltip="Tragen Sie ein, wie viele Stunden produktiv gearbeitet wurde und wie viele Stunden durch Warten, Umsetzen oder Unterbrechungen verloren gingen. Diese Information ist nur für Ihre interne Bewertung bestimmt." matTooltipPosition="right" matTooltipClass="intern-tooltip">info_outline</mat-icon>
              </div>
              <div class="intern-field-row">
                <mat-form-field appearance="outline" class="full-width compact-field intern-form-field">
                  <mat-label>Interner Vorgangsbezug</mat-label>
                  <textarea matInput rows="2" formControlName="internerVorgangsbezug" placeholder="z. B. NT-2026-014 – zusätzliche Leistung"></textarea>
                </mat-form-field>
                <mat-icon class="intern-info-icon" matTooltip="Verknüpfen Sie den Eintrag mit einem internen Vorgang, zum Beispiel Nachtrag, Behinderung, Rechnungsbezug oder besonderem Leistungsfall. Dieses Feld dient Ihrer späteren Nachverfolgung und wird nicht exportiert." matTooltipPosition="right" matTooltipClass="intern-tooltip">info_outline</mat-icon>
              </div>
              <div class="intern-field-row">
                <mat-form-field appearance="outline" class="full-width compact-field intern-form-field">
                  <mat-label>Interne Bewertung / Hinweis</mat-label>
                  <textarea matInput rows="2" formControlName="interneBewertungHinweis" placeholder="z. B. Tagesleistung unter Soll wegen verspäteter Freigabe"></textarea>
                </mat-form-field>
                <mat-icon class="intern-info-icon" matTooltip="Hinterlegen Sie eine kurze interne Einschätzung zum Tagesverlauf, zum Beispiel Ursachen für Abweichungen, organisatorische Probleme oder Hinweise für die Nachkalkulation. Dieses Feld bleibt intern." matTooltipPosition="right" matTooltipClass="intern-tooltip">info_outline</mat-icon>
              </div>
            </mat-card>

          </div><!-- END LEFT COLUMN -->

          <!-- ===== RIGHT COLUMN: Optional sections catalog ===== -->
          <aside class="bautagebuch-sidepanel" *ngIf="!isReadOnlyPreview">
            <h3>Weitere Abschnitte (optional)</h3>

            <div *ngFor="let group of tagesberichtNUOptionalCatalogGroups; trackBy: trackBySectionId" class="catalog-group">
              <h4 *ngIf="group.title && group.title !== 'Weitere Einträge'">{{ group.title }}</h4>
              <div *ngFor="let section of group.sections; trackBy: trackBySectionId" class="catalog-item">
                <div>
                  <strong>{{ section.title }}</strong>
                  <p *ngIf="section.previewFields?.length">{{ section.previewFields.join(' · ') }}</p>
                </div>
                <button mat-stroked-button color="primary" (click)="addTagesberichtNUSection(section.id)">Hinzufügen</button>
              </div>
            </div>

            <p *ngIf="tagesberichtNUOptionalCatalogGroups.length === 0" class="hint-text">Alle verfügbaren Abschnitte wurden bereits hinzugefügt.</p>
          </aside><!-- END RIGHT COLUMN -->

        </div><!-- END TWO-COLUMN LAYOUT -->
        </ng-container>
      </div><!-- END formGroup wrapper -->
    </mat-card-content>

    <mat-card-actions class="sticky-actions" *ngIf="!loading && !error">
      <button mat-button (click)="onCancel()">{{ isReadOnlyPreview ? 'Schließen' : 'Abbrechen' }}</button>
      <span class="spacer"></span>
      <ng-container *ngIf="!isReadOnlyPreview">
        <button mat-stroked-button (click)="onSave()" [disabled]="isNuUiBusy">Entwurf speichern</button>
        <button mat-stroked-button (click)="onSaveAndClose()" [disabled]="isNuUiBusy">Speichern &amp; schließen</button>
        <button mat-raised-button color="primary" class="nu-primary-footer-action" (click)="finaliseTagesberichtNU()" [disabled]="isNuUiBusy">Finalisieren</button>
      </ng-container>
    </mat-card-actions>
  </ng-container>
  <!-- ===== END TAGESBERICHT NACHUNTERNEHMER MODE ===== -->

  <ng-container *ngIf="!isTagesberichtNUMode">
  <ng-container *ngIf="isBautagebuchMode; else standardFormMode">
    <mat-card-header class="bautagebuch-header">
      <div class="bautagebuch-title-row">
        <div class="header-title-group">
          <span class="header-title-icon" aria-hidden="true">
            <mat-icon>description</mat-icon>
          </span>
          <div>
            <mat-card-title>Bautagebuch</mat-card-title>
            <mat-card-subtitle>Schnellformular mit Kernfeldern und optionalen Bereichen</mat-card-subtitle>
          </div>
        </div>
        <div class="view-toggle" *ngIf="!isReadOnlyPreview">
          <button mat-stroked-button [color]="bautagebuchViewMode === 'quick' ? 'primary' : undefined" (click)="setBautagebuchViewMode('quick')">Schnellformular</button>
          <button mat-stroked-button [color]="bautagebuchViewMode === 'schema' ? 'primary' : undefined" (click)="setBautagebuchViewMode('schema')">Schema</button>
        </div>
      </div>
    </mat-card-header>

    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <mat-card-content *ngIf="error">
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{error}}</span>
      </div>
    </mat-card-content>

    <mat-card-content *ngIf="!loading && !error && form" class="bautagebuch-content" [class.read-only-preview-content]="isReadOnlyPreview" #scrollableContent>
      <div *ngIf="isReadOnlyPreview" class="read-only-notice read-only-notice--workspace">
        <mat-icon>visibility</mat-icon>
        <span>Vorschau-Modus: Das Bautagebuch ist formatiert lesbar, aber nicht bearbeitbar.</span>
      </div>

      <div class="bautagebuch-top-row">
        <mat-form-field appearance="outline" class="compact-field date-field">
          <mat-label>Datum</mat-label>
          <input matInput
            [matDatepicker]="bautagebuchDatePicker"
            [formControl]="datumPickerControl"
            placeholder="DD.MM.YYYY"
            (dateChange)="onBautagebuchDateChange($event.value)">
          <mat-datepicker-toggle matSuffix [for]="bautagebuchDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #bautagebuchDatePicker></mat-datepicker>
          <mat-error *ngIf="datumPickerControl.hasError('matDatepickerParse')">Ungültiges Datum</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="compact-field date-field readonly-like-field">
          <mat-label>Bearbeiter</mat-label>
          <input matInput [value]="bearbeiterSummaryName || 'Nicht gesetzt'" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="compact-field preset-select top-row-select">
          <mat-label>Vorlage</mat-label>
          <mat-select [value]="bautagebuchTemplateId" (selectionChange)="applyBautagebuchTemplate($event.value)">
            <mat-option [value]="null">Keine Vorlage</mat-option>
            <mat-option *ngFor="let template of bautagebuchTemplates" [value]="template.id">{{ template.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="toolbar-actions top-row-actions">
          <button mat-stroked-button color="primary" (click)="saveBautagebuchTemplate(false)">Vorlage speichern</button>
          <button mat-stroked-button (click)="saveBautagebuchTemplate(true)" [disabled]="!bautagebuchTemplateId">Vorlage aktualisieren</button>
          <button mat-stroked-button color="warn" (click)="deleteBautagebuchTemplate()" [disabled]="!bautagebuchTemplateId">Vorlage löschen</button>
          <span class="draft-chip">Entwurf gespeichert</span>
        </div>
      </div>

      <div *ngIf="bautagebuchViewMode === 'schema'" class="schema-mode-content">
        <mat-progress-bar mode="indeterminate" *ngIf="bautagebuchSchemaLoading"></mat-progress-bar>

        <div *ngIf="bautagebuchSchemaError" class="error-message schema-status-message">
          <mat-icon>error</mat-icon>
          <span>{{ bautagebuchSchemaError }}</span>
        </div>

        <div *ngIf="!bautagebuchSchemaLoading && !bautagebuchSchemaError && bautagebuchSchemaSections.length" class="schema-shell">
          <div class="schema-direct-view">
            <div class="schema-direct-header">
              <h3>Bautagebuch</h3>
              <p>Wurzelelement eines Bautagebuchs für genau ein Bauvorhaben bzw. einen Bauvertrag.</p>
            </div>

            <div class="schema-group" *ngFor="let group of bautagebuchSections?.groups; trackBy: trackBySectionId">
              <h4>{{ group.title }}</h4>

              <mat-card class="schema-section-card" *ngFor="let section of group.sections; trackBy: trackBySectionId">
                <div class="schema-section-header">
                  <div>
                    <strong>{{ section.title }}</strong>
                    <p>{{ section.schemaPath }}</p>
                  </div>
                  <span class="schema-section-chip" [class.default]="section.enabledByDefault">
                    {{ section.enabledByDefault ? 'Standard' : 'Optional' }}
                  </span>
                </div>

                <div class="schema-preview-fields" *ngIf="section.previewFields?.length">
                  <span *ngFor="let field of section.previewFields; trackBy: trackByString">{{ field }}</span>
                </div>

                <div class="schema-field-list" *ngIf="getSchemaSectionFields(section.id).length; else noSchemaFields">
                  <div class="schema-field-row" *ngFor="let field of getSchemaSectionFields(section.id); trackBy: trackByFieldName">
                    <ng-container [ngSwitch]="field.type">
                      <mat-form-field *ngSwitchCase="'string'" appearance="outline" class="full-width">
                        <mat-label>{{ field.label || field.name }}</mat-label>
                        <input
                          matInput
                          [required]="field.required"
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                        <mat-hint class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </mat-hint>
                      </mat-form-field>

                      <mat-form-field *ngSwitchCase="'integer'" appearance="outline" class="full-width">
                        <mat-label>{{ field.label || field.name }}</mat-label>
                        <input
                          matInput
                          type="number"
                          [required]="field.required"
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                        <mat-hint class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </mat-hint>
                      </mat-form-field>

                      <mat-form-field *ngSwitchCase="'date'" appearance="outline" class="full-width">
                        <mat-label>{{ field.label || field.name }}</mat-label>
                        <input
                          matInput
                          type="date"
                          [required]="field.required"
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                        <mat-hint class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </mat-hint>
                      </mat-form-field>

                      <mat-form-field *ngSwitchCase="'code'" appearance="outline" class="full-width">
                        <mat-label>{{ field.label || field.name }}</mat-label>
                        <mat-select
                          [required]="field.required"
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                          <mat-option value="">(bitte wählen)</mat-option>
                          <mat-option *ngFor="let opt of field.codeOptions; trackBy: trackByCode" [value]="opt.value">
                            {{ opt.value }} - {{ opt.label }}
                          </mat-option>
                        </mat-select>
                        <mat-hint class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </mat-hint>
                      </mat-form-field>

                      <div *ngSwitchCase="'boolean'" class="schema-boolean-row">
                        <mat-slide-toggle
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                          {{ field.label || field.name }}
                        </mat-slide-toggle>
                        <span class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </span>
                      </div>

                      <mat-form-field *ngSwitchDefault appearance="outline" class="full-width">
                        <mat-label>{{ field.label || field.name }}</mat-label>
                        <input
                          matInput
                          [required]="field.required"
                          [ngModel]="getSchemaFieldValue(section.id, field.name)"
                          (ngModelChange)="setSchemaFieldValue(section.id, field.name, $event)"
                          [ngModelOptions]="{standalone: true}">
                        <mat-hint class="schema-field-meta">
                          {{ field.type }}<ng-container *ngIf="field.required"> • Pflichtfeld</ng-container>
                        </mat-hint>
                      </mat-form-field>
                    </ng-container>
                  </div>
                </div>

                <ng-template #noSchemaFields>
                  <div class="schema-empty-state">Keine Felder für diesen Bereich gefunden.</div>
                </ng-template>
              </mat-card>
            </div>
          </div>
        </div>
      </div>

      <form *ngIf="bautagebuchViewMode === 'quick'" [formGroup]="form" class="bautagebuch-layout bautagebuch-form">
        <div class="bautagebuch-main">
          <mat-card class="section-card dataspace-panel">
            <div class="summary-card-header">
              <div>
                <mat-card-title>Dataspace Import</mat-card-title>
                <div class="summary-meta">Freigegebene NU-Tagesberichte in dieses Bautagebuch übernehmen</div>
              </div>
            </div>

            <div class="form-grid two-columns">
              <mat-form-field appearance="outline" class="compact-field">
                <mat-label>Projektschlüssel</mat-label>
                <input matInput [(ngModel)]="dataspaceCatalogProjectKey" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <mat-form-field appearance="outline" class="compact-field">
                <mat-label>Berichtsdatum</mat-label>
                <input matInput type="date" [(ngModel)]="dataspaceCatalogReportDate" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>

            <div class="section-card-actions dataspace-actions">
              <button mat-stroked-button color="primary" type="button" (click)="loadDataspaceCatalog()" [disabled]="dataspaceCatalogLoading">
                Katalog laden
              </button>
              <button mat-raised-button color="primary" type="button" (click)="importSelectedDataspaceAssets()" [disabled]="dataspaceImportBusy || dataspaceSelectedAssetIds.length === 0">
                Auswahl importieren
              </button>
            </div>

            <div *ngIf="dataspaceCatalogItems.length === 0 && !dataspaceCatalogLoading" class="bt-empty-hint">
              Noch keine Dataspace-Assets geladen.
            </div>

            <div *ngIf="dataspaceCatalogItems.length > 0" class="dataspace-catalog-list">
              <div *ngFor="let item of dataspaceCatalogItems; trackBy: trackByAssetId" class="dataspace-catalog-item">
                <mat-checkbox
                  [checked]="isDataspaceAssetSelected(item.assetId)"
                  (change)="onDataspaceAssetSelectionChange(item.assetId, $event.checked)">
                </mat-checkbox>
                <div class="dataspace-catalog-copy">
                  <strong>{{ item.producerOrgName }}</strong>
                  <span>{{ item.projectKey }} · {{ item.reportDate || 'ohne Datum' }}</span>
                  <span>{{ item.releasedSectionIds.join(', ') }}</span>
                  <span>{{ getDataspacePolicyTermsSummary(item.policyTerms) }}</span>
                  <div *ngIf="isDataspaceAssetSelected(item.assetId)" class="dataspace-section-picks">
                    <strong>GU-Auswahl</strong>
                    <ng-container *ngIf="getDataspaceSelectableSections(item).length > 0; else dataspaceAutoOnly">
                      <mat-checkbox
                        *ngFor="let sectionId of getDataspaceSelectableSections(item); trackBy: trackByString"
                        [checked]="isDataspaceSectionSelected(item.assetId, sectionId)"
                        (change)="onDataspaceSectionSelectionChange(item.assetId, sectionId, $event.checked)">
                        {{ prettyDataspaceSectionLabel(sectionId) }}
                      </mat-checkbox>
                    </ng-container>
                    <ng-template #dataspaceAutoOnly>
                      <span>Nur automatische Übernahme von Projekt, Tag und Wetter.</span>
                    </ng-template>
                  </div>
                </div>
                <button mat-stroked-button type="button" (click)="previewDataspaceAsset(item.assetId)" [disabled]="dataspaceCatalogLoading">
                  Vorschau
                </button>
              </div>
            </div>

            <div *ngIf="dataspacePreview" class="dataspace-preview">
              <div class="optional-editor-header">
                <div>
                  <h4>Asset-Vorschau</h4>
                  <p>{{ dataspacePreview.assetId }} · {{ dataspacePreview.purpose }}</p>
                </div>
              </div>
              <pre>{{ dataspacePreview.payload | json }}</pre>
            </div>

            <div *ngIf="dataspaceImportPreview?.warnings?.length" class="dataspace-warning-list">
              <strong>Importhinweise</strong>
              <div *ngFor="let warning of dataspaceImportPreview?.warnings; trackBy: trackByString">{{ warning }}</div>
            </div>
          </mat-card>

          <div class="bautagebuch-summary-grid">
            <mat-card class="section-card section-card-compact">
              <div class="summary-card-header">
                <div>
                  <mat-card-title>Projekt</mat-card-title>
                  <ng-container *ngIf="!showProjectEditor">
                    <div class="summary-title">{{ projectSummaryTitle }}</div>
                    <div class="summary-meta">{{ projectSummaryMeta }}</div>
                  </ng-container>
                </div>
                <button mat-icon-button class="icon-action-button" (click)="showProjectEditor = !showProjectEditor" [attr.aria-label]="showProjectEditor ? 'Projekteditor schließen' : 'Projekteditor öffnen'">
                  <mat-icon>{{ showProjectEditor ? 'expand_less' : 'edit' }}</mat-icon>
                </button>
              </div>

              <div formGroupName="project" *ngIf="showProjectEditor" class="summary-editor">
                <div formGroupName="auftraggeber">
                  <div class="form-grid">
                    <mat-form-field appearance="outline" class="compact-field">
                      <mat-label>Auftraggeber</mat-label>
                      <input matInput formControlName="name">
                    </mat-form-field>
                  </div>

                  <div formGroupName="adresse" class="form-grid five-columns">
                    <mat-form-field appearance="outline" class="compact-field"><mat-label>Straße</mat-label><input matInput formControlName="strasse"></mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field"><mat-label>Nr.</mat-label><input matInput formControlName="hausnummer"></mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field"><mat-label>PLZ</mat-label><input matInput formControlName="plz"></mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field"><mat-label>Ort</mat-label><input matInput formControlName="ort"></mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field"><mat-label>Land</mat-label><input matInput formControlName="land"></mat-form-field>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="full-width compact-field">
                  <mat-label>Bezeichnung der Baumaßnahme</mat-label>
                  <input matInput formControlName="bezeichnungDerBaumassnahme">
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="section-card section-card-compact">
              <div class="summary-card-header">
                <div>
                  <mat-card-title class="weather-summary-title"><mat-icon>{{ weatherSummaryIcon }}</mat-icon><span>Wetter</span></mat-card-title>
                  <ng-container *ngIf="!showWeatherEditor">
                    <div class="summary-title">{{ weatherSummaryTitle }}</div>
                    <div class="summary-meta">{{ weatherSummaryMeta }}</div>
                  </ng-container>
                </div>
                <button mat-icon-button class="icon-action-button" (click)="showWeatherEditor = !showWeatherEditor" [attr.aria-label]="showWeatherEditor ? 'Wettereditor schließen' : 'Wettereditor öffnen'">
                  <mat-icon>{{ showWeatherEditor ? 'expand_less' : 'edit' }}</mat-icon>
                </button>
              </div>

              <div formGroupName="weather" *ngIf="showWeatherEditor" class="summary-editor">
                <div class="weather-api-note">Temperaturdaten werden automatisch aus externer API übernommen.</div>
                <div class="weather-editor-grid">
                  <mat-form-field appearance="outline" class="compact-field">
                    <mat-label>Wetterlage</mat-label>
                    <mat-select formControlName="tageslage">
                      <mat-option *ngFor="let option of filteredWeatherOptions | async; trackBy: trackByOptionValue" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="compact-field temperature-field weather-temperature-field"><mat-label>Min. Temperatur</mat-label><input matInput type="number" formControlName="temperaturMinC"><span matTextSuffix>°C</span></mat-form-field>
                  <mat-form-field appearance="outline" class="compact-field temperature-field weather-temperature-field"><mat-label>Max. Temperatur</mat-label><input matInput type="number" formControlName="temperaturMaxC"><span matTextSuffix>°C</span></mat-form-field>
                </div>
                <div class="weather-editor-grid weather-editor-grid-secondary">
                  <mat-form-field appearance="outline" class="compact-field weather-small-field"><mat-label>Niederschlag</mat-label><input matInput type="number" formControlName="niederschlagProzent"><span matTextSuffix>%</span></mat-form-field>
                  <mat-form-field appearance="outline" class="compact-field weather-small-field"><mat-label>Wind</mat-label><input matInput type="number" formControlName="windGeschwindigkeitKmh"><span matTextSuffix>km/h</span></mat-form-field>
                  <mat-form-field appearance="outline" class="compact-field"><mat-label>Windrichtung</mat-label><input matInput formControlName="windRichtung" placeholder="Osten"></mat-form-field>
                </div>

                <div formArrayName="messungen" class="measurement-list">
                  <div *ngFor="let measurement of weatherMeasurementControls; let i = index; trackBy: trackByControl" [formGroupName]="i" class="measurement-row">
                    <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Uhrzeit</mat-label><input matInput type="time" formControlName="uhrzeit"></mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field weather-kind-field">
                      <mat-label>Wetterlage</mat-label>
                      <mat-select formControlName="wetterlage">
                        <mat-option *ngFor="let option of filteredWeatherOptions | async; trackBy: trackByOptionValue" [value]="option.label">{{ option.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="compact-field temperature-field weather-temperature-field"><mat-label>Temperatur</mat-label><input matInput type="number" formControlName="temperaturC"><span matTextSuffix>°C</span></mat-form-field>
                    <mat-form-field appearance="outline" class="full-width compact-field"><mat-label>Notiz</mat-label><input matInput formControlName="notiz"></mat-form-field>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="full-width compact-field">
                  <mat-label>Bemerkung</mat-label>
                  <textarea matInput rows="3" formControlName="bemerkung"></textarea>
                </mat-form-field>
              </div>
            </mat-card>
          </div>

          <mat-card class="section-card" *ngIf="bautagebuchImportedSources.length > 0">
            <mat-card-title>Importierte NU-Zusammenfassungen</mat-card-title>
            <div class="company-report-list">
              <div *ngFor="let source of bautagebuchImportedSources; trackBy: trackByAssetId" class="company-report-card imported-source-card">
                <div class="company-report-header">
                  <div class="company-report-header-main">
                    <strong class="company-report-title">{{ getImportedSourceTitle(source) }}</strong>
                    <div class="summary-meta">{{ getImportedSourceMeta(source) }}</div>
                  </div>
                  <button mat-stroked-button type="button" (click)="openImportedSourcePreview(source)">
                    Tagesbericht ansehen
                  </button>
                </div>
                <div class="company-report-grid company-report-grid-wide">
                  <div class="report-column">
                    <h4>Arbeitskräfte</h4>
                    <div class="imported-summary-list" *ngIf="getImportedSourceWorkerSummary(source).length > 0; else noImportedWorkers">
                      <div *ngFor="let line of getImportedSourceWorkerSummary(source); trackBy: trackByString" class="imported-summary-line">
                        {{ line }}
                      </div>
                    </div>
                    <ng-template #noImportedWorkers>
                      <div class="bt-empty-hint">Keine Arbeitskräfte aus dem NU-Bericht übernommen.</div>
                    </ng-template>
                  </div>
                  <div class="report-column">
                    <h4>Arbeiten / Fortschritt / Sonstiges</h4>
                    <div class="imported-summary-list" *ngIf="getImportedSourceWorkSummary(source).length > 0; else noImportedWork">
                      <div *ngFor="let line of getImportedSourceWorkSummary(source); trackBy: trackByString" class="imported-summary-line">
                        {{ line }}
                      </div>
                    </div>
                    <ng-template #noImportedWork>
                      <div class="bt-empty-hint">Keine Arbeits- oder Fortschrittsangaben ausgewählt.</div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>

          <mat-card class="section-card">
            <mat-card-title>Firmenberichte</mat-card-title>
            <div formArrayName="companyReports" class="company-report-list">
              <div *ngFor="let report of companyReportEntries; let reportIndex = index; trackBy: trackByCompanyReport" [formGroupName]="report.reportIndex" class="company-report-card">
                <div class="company-report-header">
                  <div class="company-report-header-main">
                    <strong class="company-report-title">Bericht {{ reportIndex + 1 }}</strong>
                    <div class="company-report-inline-fields">
                      <div formGroupName="firma">
                        <mat-form-field appearance="outline" class="company-report-company-field"><mat-label>Firma</mat-label><input matInput formControlName="name"></mat-form-field>
                      </div>
                      <div class="company-report-time-groups">
                        <div class="company-report-time-group">
                          <div class="company-report-inline-group-text">
                            <span class="company-report-inline-group-label">Arbeitszeit:</span>
                            <span class="company-report-inline-group-duration" *ngIf="getCompanyReportDurationLabel(report.reportControl, 'arbeitszeit') as duration">({{ duration }} h)</span>
                          </div>
                          <div formGroupName="arbeitszeit" class="company-report-time-fields">
                            <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Beginn</mat-label><input matInput type="time" formControlName="beginn"></mat-form-field>
                            <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Ende</mat-label><input matInput type="time" formControlName="ende"></mat-form-field>
                          </div>
                        </div>

                        <div class="company-report-time-group">
                          <div class="company-report-inline-group-text">
                            <span class="company-report-inline-group-label">Schlechtes Wetter:</span>
                            <span class="company-report-inline-group-duration" *ngIf="getCompanyReportDurationLabel(report.reportControl, 'schlechtesWetter') as duration">({{ duration }} h)</span>
                          </div>
                          <div formGroupName="schlechtesWetter" class="company-report-time-fields">
                            <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Beginn</mat-label><input matInput type="time" formControlName="beginn"></mat-form-field>
                            <mat-form-field appearance="outline" class="compact-field time-field"><mat-label>Ende</mat-label><input matInput type="time" formControlName="ende"></mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button mat-icon-button color="warn" class="icon-action-button" (click)="removeCompanyReport(report.reportIndex)" *ngIf="companyReportEntries.length > 1">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <div class="company-report-grid company-report-grid-wide">
                  <div class="report-column">
                    <h4>Arbeitskräfte</h4>
                    <div formArrayName="arbeitskraefte">
                      <div *ngFor="let worker of report.workerControls; let workerIndex = index; trackBy: trackByControl" [formGroupName]="workerIndex" class="worker-card">
                        <div class="worker-row">
                          <mat-form-field appearance="outline">
                            <mat-label>Qualifikation</mat-label>
                            <mat-select [value]="isWorkerFieldCustom(report.reportIndex, workerIndex, 'qualifikation') ? customWorkerOptionValue : worker.get('qualifikation')?.value" (selectionChange)="onWorkerOptionChange(report.reportIndex, workerIndex, 'qualifikation', $event.value)">
                              <mat-option *ngFor="let option of workerQualificationOptions; trackBy: trackByOptionValue" [value]="option.value">{{ option.label }}</mat-option>
                              <mat-option [value]="customWorkerOptionValue"><span class="multiline-option">Benutzer-<br>definiert</span></mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline"><mat-label>Anzahl</mat-label><input matInput type="number" formControlName="anzahl"></mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Lohngruppe</mat-label>
                            <mat-select [value]="isWorkerFieldCustom(report.reportIndex, workerIndex, 'lohngruppe') ? customWorkerOptionValue : worker.get('lohngruppe')?.value" (selectionChange)="onWorkerOptionChange(report.reportIndex, workerIndex, 'lohngruppe', $event.value)">
                              <mat-option value="">Keine Auswahl</mat-option>
                              <mat-option *ngFor="let option of workerLohngruppeOptions; trackBy: trackByOptionValue" [value]="option.value">{{ option.label }}</mat-option>
                              <mat-option [value]="customWorkerOptionValue"><span class="multiline-option">Benutzer-<br>definiert</span></mat-option>
                            </mat-select>
                          </mat-form-field>
                          <button mat-icon-button color="warn" class="icon-action-button" (click)="removeWorker(report.reportIndex, workerIndex)" *ngIf="report.workerControls.length > 1">
                            <mat-icon>remove_circle</mat-icon>
                          </button>
                        </div>
                        <div class="worker-custom-fields" *ngIf="isWorkerFieldCustom(report.reportIndex, workerIndex, 'qualifikation') || isWorkerFieldCustom(report.reportIndex, workerIndex, 'lohngruppe')">
                          <mat-form-field appearance="outline" class="worker-custom-field" *ngIf="isWorkerFieldCustom(report.reportIndex, workerIndex, 'qualifikation')">
                            <mat-label>Qualifikation benutzerdefiniert</mat-label>
                            <input matInput formControlName="qualifikation">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="worker-custom-field" *ngIf="isWorkerFieldCustom(report.reportIndex, workerIndex, 'lohngruppe')">
                            <mat-label>Lohngruppe benutzerdefiniert</mat-label>
                            <input matInput formControlName="lohngruppe">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <button mat-stroked-button (click)="addWorker(report.reportIndex)">+ Arbeitskraft</button>
                  </div>

                  <div class="report-column">
                    <h4>Arbeiten / Fortschritt / Sonstiges</h4>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Ausgeführte Arbeiten</mat-label>
                      <textarea matInput rows="3" formControlName="ausgefuehrteArbeiten"></textarea>
                      <button mat-icon-button matSuffix type="button" class="field-help-button" [matTooltip]="'Welche konkreten Arbeiten wurden heute ausgeführt? Beispiel: Leitungsgraben hergestellt, Rohre verlegt, Oberfläche vorbereitet.'" matTooltipPosition="above">
                        <mat-icon>help_outline</mat-icon>
                      </button>
                    </mat-form-field>
                    <button
                      *ngIf="floorplanPreviewMedia"
                      type="button"
                      class="work-media-preview"
                      (click)="openFloorplanOverlay('door')"
                      [attr.aria-label]="'Bild vergrößern: ' + floorplanPreviewMedia.title">
                      <img
                        [src]="floorplanPreviewMedia.thumbnailSrc || floorplanPreviewMedia.src"
                        [alt]="floorplanPreviewMedia.title">
                      <span class="work-media-preview-copy">
                        <strong>{{ floorplanPreviewMedia.title }}</strong>
                        <span>{{ floorplanPreviewMedia.description || 'Tür wurde montiert' }}</span>
                      </span>
                    </button>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Arbeitsfortschritt</mat-label>
                      <textarea matInput rows="3" formControlName="arbeitsfortschritt"></textarea>
                      <button mat-icon-button matSuffix type="button" class="field-help-button" [matTooltip]="'Wie weit ist der Abschnitt fortgeschritten? Beispiel: Abschnitt Nord zu 60 Prozent abgeschlossen, Asphalttragschicht begonnen.'" matTooltipPosition="above">
                        <mat-icon>help_outline</mat-icon>
                      </button>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Sonstiges</mat-label>
                      <textarea matInput rows="3" formControlName="sonstiges"></textarea>
                      <button mat-icon-button matSuffix type="button" class="field-help-button" [matTooltip]="'Besondere Hinweise, Abstimmungen oder Beobachtungen. Beispiel: Lieferverzug, Verkehrsführung angepasst, kurze Unterbrechung wegen Fremdgewerk.'" matTooltipPosition="above">
                        <mat-icon>help_outline</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <button mat-stroked-button color="primary" (click)="addCompanyReport()">+ Bericht hinzufügen</button>
          </mat-card>

          <mat-card class="section-card optional-zone-card" *ngIf="bautagebuchActiveOptionalSections.length > 0">
            <div class="optional-chip-list">
              <button mat-stroked-button type="button" class="optional-chip" *ngFor="let section of bautagebuchActiveOptionalSections; trackBy: trackBySectionId" [class.active]="activeOptionalSectionId === section.id" (click)="openOptionalSection(section.id)">
                <span>{{ section.title }}</span>
                <span class="optional-chip-count">{{ section.entryCount }}</span>
              </button>
            </div>

            <div *ngFor="let section of bautagebuchActiveOptionalSections; trackBy: trackBySectionId" class="optional-editor" [class.hidden]="activeOptionalSectionId !== section.id">
              <div class="optional-editor-header">
                <div>
                  <h4>{{ section.title }}</h4>
                  <p>{{ section.previewFields.join(' • ') }}</p>
                </div>
                <button mat-icon-button color="warn" class="icon-action-button" (click)="removeBautagebuchSection(section.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <ng-container [ngSwitch]="section.id">
                <div *ngSwitchCase="'dokumentation'" formGroupName="dokumentation">
                  <div formArrayName="notizen">
                    <div *ngFor="let note of section.items; let i = index; trackBy: trackByControl" class="documentation-row">
                      <mat-form-field appearance="outline" class="full-width"><mat-label>Notiz</mat-label><textarea matInput rows="2" [formControlName]="i"></textarea></mat-form-field>
                      <button mat-icon-button color="warn" class="icon-action-button" (click)="removeDocumentationNote(i)"><mat-icon>delete</mat-icon></button>
                    </div>
                  </div>
                  <div class="section-card-actions">
                    <button mat-stroked-button (click)="addDocumentationNote()">Notiz hinzufügen</button>
                  </div>
                </div>

                <div *ngSwitchCase="'freitext'">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Freitext</mat-label>
                    <textarea matInput rows="4" formControlName="freitext"></textarea>
                  </mat-form-field>
                </div>

                <div *ngSwitchDefault [formArrayName]="section.id">
                  <div *ngFor="let item of section.items; let i = index; trackBy: trackByControl" [formGroupName]="i" class="optional-card">
                    <div class="form-grid three-columns">
                      <mat-form-field appearance="outline" *ngFor="let field of section.fields; trackBy: trackByFieldKey">
                        <mat-label>{{ field.label }}</mat-label>
                        <ng-container [ngSwitch]="field.inputType">
                          <mat-select *ngSwitchCase="'select'" [formControlName]="field.key">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</mat-option>
                          </mat-select>
                          <input *ngSwitchDefault matInput [type]="field.inputType" [formControlName]="field.key">
                        </ng-container>
                      </mat-form-field>
                    </div>
                    <button mat-stroked-button color="warn" (click)="removeOptionalItem(section.id, i)">Eintrag entfernen</button>
                  </div>
                  <div class="section-card-actions">
                    <button mat-stroked-button (click)="addOptionalItem(section.id)">Eintrag hinzufügen</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-card>
        </div>

        <aside class="bautagebuch-sidepanel">
          <h3>Weitere Einträge (optional)</h3>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Suchen</mat-label>
            <input matInput [ngModel]="bautagebuchSearch" (ngModelChange)="onBautagebuchSearchChange($event)" [ngModelOptions]="{standalone: true}">
          </mat-form-field>

          <div *ngFor="let group of bautagebuchOptionalCatalogGroups; trackBy: trackBySectionId" class="catalog-group">
            <h4 *ngIf="group.title !== 'Weitere Einträge'">{{ group.title }}</h4>
            <div *ngFor="let section of group.sections; trackBy: trackBySectionId" class="catalog-item">
              <div>
                <strong>{{ section.title }}</strong>
                <p>{{ section.previewFields.join(' • ') }}</p>
              </div>
              <button mat-stroked-button color="primary" (click)="addBautagebuchSection(section.id)">Hinzufügen</button>
            </div>
          </div>
        </aside>
      </form>
    </mat-card-content>

    <mat-card-actions class="sticky-actions" *ngIf="bautagebuchViewMode === 'quick'; else bautagebuchSchemaActions">
      <button mat-button (click)="onCancel()">{{ isReadOnlyPreview ? 'Schließen' : 'Abbrechen' }}</button>
      <span class="spacer"></span>
      <ng-container *ngIf="!isReadOnlyPreview">
        <button mat-stroked-button color="primary" (click)="onSave()" [disabled]="loading">Entwurf speichern</button>
        <button mat-raised-button color="primary" (click)="onSaveAndClose()" [disabled]="loading">Speichern &amp; schließen</button>
        <button mat-stroked-button (click)="previewBautagebuchXml()" [disabled]="loading">XML Vorschau</button>
      </ng-container>
    </mat-card-actions>

    <ng-template #bautagebuchSchemaActions>
      <mat-card-actions class="sticky-actions">
        <button mat-button (click)="onCancel()">Schließen</button>
        <span class="spacer"></span>
        <button mat-stroked-button *ngIf="!isReadOnlyPreview" (click)="setBautagebuchViewMode('quick')">Zum Schnellformular</button>
      </mat-card-actions>
    </ng-template>

    <div
      *ngIf="isFloorplanOverlayOpen"
      class="floorplan-overlay"
      (click)="closeFloorplanOverlay()"
      role="dialog"
      aria-modal="true"
      aria-label="Grundriss mit markierter Position">
      <div class="floorplan-overlay-dialog" (click)="$event.stopPropagation()">
        <div class="floorplan-overlay-header">
          <div>
            <span class="location-preview-eyebrow">Zusatzansicht</span>
            <h3>Grundriss 4. OG</h3>
          </div>
          <button mat-icon-button type="button" (click)="closeFloorplanOverlay()" aria-label="Grundriss schließen">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="floorplan-overlay-layout">
          <div class="floorplan-stage">
            <img class="floorplan-image" [src]="floorplanConfig.imageSrc" alt="Grundriss 4. OG">

            <button
              *ngFor="let marker of floorplanConfig.markers; trackBy: trackByMarkerId"
              type="button"
              class="floorplan-marker"
              [class.active]="selectedFloorplanMarkerId === marker.id"
              [ngStyle]="getFloorplanMarkerStyle(marker)"
              (click)="selectFloorplanMarker(marker.id)"
              [attr.aria-label]="marker.label">
              <span class="floorplan-marker-dot"></span>
              <span class="floorplan-marker-label">{{ marker.label }}</span>
            </button>
          </div>

          <div class="floorplan-media-panel" *ngIf="selectedFloorplanMarker as marker">
            <h4>{{ marker.label }}</h4>
            <p>Markierte Position bei {{ marker.x }} px / {{ marker.y }} px im Originalbild.</p>

            <div class="floorplan-media-list">
              <div class="floorplan-media-card" *ngFor="let media of marker.media; trackBy: trackByMediaId">
                <img *ngIf="media.type === 'image'" [src]="media.src" [alt]="media.title">
                <div class="floorplan-media-meta">
                  <strong>{{ media.title }}</strong>
                  <span>{{ media.description || 'Verknüpft mit dieser Position' }}</span>
                </div>
              </div>
            </div>

            <button mat-stroked-button type="button" (click)="closeFloorplanOverlay()">Schließen</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #standardFormMode>
    <mat-card-header *ngIf="messageTypeConfig">
      <mat-card-title>{{ messageTypeConfig.title }}</mat-card-title>
      <mat-card-subtitle>{{ messageTypeConfig.description }}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-header *ngIf="!isMultiPage">
      <mat-card-title>{{sectionTitle}}</mat-card-title>
    </mat-card-header>

    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <mat-card-content *ngIf="error">
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{error}}</span>
      </div>
    </mat-card-content>

    <mat-card-content *ngIf="isMultiPage && !loading && !error && form" class="wizard-container" #scrollableContent>
      <div class="sidebar">
        <h4 class="sidebar-title">Seitenstruktur</h4>
        <mat-nav-list>
          <mat-list-item *ngFor="let page of pages; let i = index" [class.active]="currentPageIndex === i" (click)="navigateToPage(i)">
            <mat-icon matListItemIcon [color]="isPageValid(i) ? 'primary' : ''">{{ isPageValid(i) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            <span matListItemTitle>{{ i + 1 }}. {{ page.title }}</span>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="content-area">
        <h3 class="page-title">{{ pages[currentPageIndex].title }}</h3>

        <div *ngIf="currentPageConfig.readOnly" class="read-only-notice">
          <mat-icon>info</mat-icon>
          <span>Diese Daten werden aus der vorherigen Nachricht übernommen und können nicht bearbeitet werden.</span>
        </div>

        <div class="scrollable-content">
          <form *ngIf="!currentPageConfig.isRepeatable" [formGroup]="form.get(currentPageConfig.formGroupName)">
            <div *ngFor="let field of allFieldDefinitions.get(currentPageConfig.formGroupName)" class="form-field-container" [hidden]="!isFieldVisible(field)">
              <mat-form-field *ngIf="field.type === 'string' && !field.codeListUrn" appearance="outline" class="full-width">
                <mat-label>{{field.label}}</mat-label>
                <input matInput [formControlName]="field.name" [required]="field.required" [type]="field.name.includes('email') ? 'email' : 'text'">
                <mat-error *ngIf="form.get(currentPageConfig.formGroupName).get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
                <mat-error *ngIf="form.get(currentPageConfig.formGroupName).get(field.name)?.hasError('email')">Ungültige E-Mail-Adresse</mat-error>
                <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
              </mat-form-field>

              <mat-form-field *ngIf="field.type === 'textarea'" appearance="outline" class="full-width">
                <mat-label>{{field.label}}</mat-label>
                <textarea matInput [formControlName]="field.name" [required]="field.required" rows="4" placeholder="Geben Sie Ihre Anmerkungen ein..."></textarea>
                <mat-error *ngIf="form.get(currentPageConfig.formGroupName).get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
                <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
              </mat-form-field>

              <mat-form-field *ngIf="field.type === 'code' && field.codeListUrn?.includes('registergerichte')" appearance="outline" class="full-width">
                <mat-label>{{field.label}}</mat-label>
                <mat-select [formControlName]="field.name" [required]="field.required">
                  <mat-option value="">(bitte wählen)</mat-option>
                  <mat-option *ngFor="let opt of filteredOptions | async; trackBy: trackByCode" [value]="opt.value">
                    <span *ngIf="opt.state">{{opt.state}} - </span>{{opt.value}} - {{opt.label}}<span *ngIf="opt.postalCode" class="postal-hint"> ({{opt.postalCode}})</span>
                  </mat-option>
                </mat-select>
                <mat-error>Pflichtfeld</mat-error>
                <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
              </mat-form-field>

              <mat-form-field *ngIf="field.type === 'code' && !field.codeListUrn?.includes('registergerichte')" appearance="outline" class="full-width">
                <mat-label>{{field.label}}</mat-label>
                <mat-select [formControlName]="field.name" [required]="field.required">
                  <mat-option value="">(bitte wählen)</mat-option>
                  <mat-option *ngFor="let opt of field.codeOptions; trackBy: trackByCode" [value]="opt.value">{{opt.value}} - {{opt.label}}</mat-option>
                </mat-select>
                <mat-error>Pflichtfeld</mat-error>
                <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
              </mat-form-field>

              <div *ngIf="field.type === 'boolean'" class="custom-toggle-wrapper">
                <span class="toggle-label">{{field.label}}</span>
                <mat-slide-toggle [formControlName]="field.name" class="custom-toggle"></mat-slide-toggle>
              </div>
            </div>
          </form>

          <div *ngIf="currentPageConfig.isRepeatable">
            <div *ngIf="getCurrentFormArray()?.length === 0" class="empty-state">
              <p>Keine Einträge vorhanden. Klicken Sie auf "Hinzufügen", um einen Eintrag zu erfassen.</p>
            </div>

            <div *ngFor="let instanceFormGroup of getCurrentFormArray()?.controls; let i = index" class="repeatable-instance">
              <div class="instance-header">
                <h4>{{ currentPageConfig.title }} {{ i + 1 }}</h4>
                <button *ngIf="getCurrentFormArray()?.length > currentPageConfig.minInstances && !currentPageConfig.lockedInstances" mat-icon-button type="button" color="warn" (click)="removeInstance(i)" class="remove-instance-btn" [matTooltip]="'Löschen'">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>

              <form [formGroup]="instanceFormGroup">
                <div *ngFor="let field of allFieldDefinitions.get(currentPageConfig.formGroupName)" class="form-field-container" [hidden]="!isFieldVisible(field, instanceFormGroup)">
                  <div *ngIf="field.displayOnly" class="display-only-field">
                    <label class="display-only-label">{{field.label}}</label>
                    <div class="display-only-value" [class.empty]="!instanceFormGroup.get(field.name)?.value">{{ instanceFormGroup.get(field.name)?.value || '(nicht angegeben)' }}</div>
                    <div *ngIf="field.description" class="display-only-hint">{{field.description}}</div>
                  </div>

                  <mat-form-field *ngIf="field.type === 'string' && !field.codeListUrn && !field.displayOnly" appearance="outline" class="full-width">
                    <mat-label>{{field.label}}</mat-label>
                    <input matInput [formControlName]="field.name" [required]="field.required" [type]="field.name.includes('email') ? 'email' : 'text'">
                    <mat-error *ngIf="instanceFormGroup.get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
                    <mat-error *ngIf="instanceFormGroup.get(field.name)?.hasError('email')">Ungültige E-Mail-Adresse</mat-error>
                    <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
                  </mat-form-field>

                  <mat-form-field *ngIf="field.type === 'textarea' && !field.displayOnly" appearance="outline" class="full-width">
                    <mat-label>{{field.label}}</mat-label>
                    <textarea matInput [formControlName]="field.name" [required]="field.required" rows="4" placeholder="Geben Sie Ihre Anmerkungen ein..."></textarea>
                    <mat-error *ngIf="instanceFormGroup.get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
                    <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
                  </mat-form-field>

                  <mat-form-field *ngIf="field.type === 'code' && field.codeListUrn?.includes('registergerichte')" appearance="outline" class="full-width">
                    <mat-label>{{field.label}}</mat-label>
                    <mat-select [formControlName]="field.name" [required]="field.required">
                      <mat-option value="">(bitte wählen)</mat-option>
                      <mat-option *ngFor="let opt of filteredOptions | async; trackBy: trackByCode" [value]="opt.value">
                        <span *ngIf="opt.state">{{opt.state}} - </span>{{opt.value}} - {{opt.label}}<span *ngIf="opt.postalCode" class="postal-hint"> ({{opt.postalCode}})</span>
                      </mat-option>
                    </mat-select>
                    <mat-error>Pflichtfeld</mat-error>
                    <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
                  </mat-form-field>

                  <mat-form-field *ngIf="field.type === 'code' && !field.codeListUrn?.includes('registergerichte')" appearance="outline" class="full-width">
                    <mat-label>{{field.label}}</mat-label>
                    <mat-select [formControlName]="field.name" [required]="field.required">
                      <mat-option value="">(bitte wählen)</mat-option>
                      <mat-option *ngFor="let opt of field.codeOptions; trackBy: trackByCode" [value]="opt.value">{{opt.value}} - {{opt.label}}</mat-option>
                    </mat-select>
                    <mat-error>Pflichtfeld</mat-error>
                    <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
                  </mat-form-field>

                  <div *ngIf="field.type === 'boolean'" class="custom-toggle-wrapper">
                    <span class="toggle-label">{{field.label}}</span>
                    <mat-slide-toggle [formControlName]="field.name" class="custom-toggle"></mat-slide-toggle>
                  </div>
                </div>
              </form>
            </div>

            <button *ngIf="!currentPageConfig.lockedInstances" mat-raised-button color="primary" type="button" (click)="addInstance()" [disabled]="getCurrentFormArray()?.length >= currentPageConfig.maxInstances" class="add-instance-btn">
              <mat-icon>add_circle</mat-icon>
              {{ currentPageConfig.title }} hinzufügen
            </button>
          </div>
        </div>

        <div class="navigation-buttons">
          <button mat-button (click)="navigateToPage(currentPageIndex - 1)" [disabled]="currentPageIndex === 0">
            <mat-icon>arrow_back</mat-icon>
            Zurück
          </button>
          <span class="spacer"></span>
          <button mat-raised-button color="primary" (click)="navigateToPage(currentPageIndex + 1)" *ngIf="currentPageIndex < pages.length - 1">
            Weiter
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>

    <mat-card-content *ngIf="!isMultiPage && !loading && !error && form">
      <form [formGroup]="form">
        <div *ngFor="let field of fieldDefinitions" class="form-field-container">
          <mat-form-field *ngIf="field.type === 'string' && !field.codeListUrn" appearance="outline" class="full-width">
            <mat-label>{{field.label}}</mat-label>
            <input matInput [formControlName]="field.name" [required]="field.required" [type]="field.name === 'email' ? 'email' : 'text'">
            <mat-error *ngIf="form.get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
            <mat-error *ngIf="form.get(field.name)?.hasError('email')">Ungültige E-Mail-Adresse</mat-error>
            <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="field.type === 'code' && field.codeOptions && field.codeOptions.length > 0" appearance="outline" class="full-width">
            <mat-label>{{field.label}}</mat-label>
            <mat-select [formControlName]="field.name" [required]="field.required">
              <mat-option *ngFor="let opt of field.codeOptions; trackBy: trackByCode" [value]="opt.value">{{opt.value}} - {{opt.label}}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get(field.name)?.hasError('required')">Pflichtfeld</mat-error>
            <mat-hint *ngIf="field.description"><span [matTooltip]="field.description" matTooltipPosition="above" matTooltipClass="field-description-tooltip" class="ellipsis-hint">{{ field.description }}</span></mat-hint>
          </mat-form-field>

          <div *ngIf="field.type === 'code' && (!field.codeOptions || field.codeOptions.length === 0)" class="error-message">
            <mat-icon>warning</mat-icon>
            <span>Keine Optionen für {{field.label}} (URN: {{field.codeListUrn}})</span>
          </div>
        </div>
      </form>
    </mat-card-content>

    <mat-card-actions *ngIf="!loading && !error">
      <button mat-raised-button color="primary" (click)="onSave()" [disabled]="loading">
        <mat-icon>save</mat-icon>
        Speichern
      </button>

      <button mat-raised-button color="primary" (click)="onSaveAndClose()" [disabled]="loading">
        <mat-icon>check</mat-icon>
        Speichern und Schließen
      </button>

      <button mat-button (click)="onCancel()">
        <mat-icon>close</mat-icon>
        Abbrechen
      </button>
    </mat-card-actions>
  </ng-template>
  </ng-container><!-- end !isTagesberichtNUMode -->
</mat-card>
